import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach JWT from localStorage if present
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Redirect to pricing/login on subscription / auth failures from gated reads
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    // Don't loop on auth endpoints (login/me/register/google/session) or the packages/terms public endpoints
    const isAuthEndpoint = /\/auth\//.test(url);
    if (!isAuthEndpoint && typeof window !== "undefined") {
      const here = window.location.pathname;
      if (status === 402 && here !== "/pricing") {
        window.location.assign("/pricing?gated=1");
      } else if (status === 401 && !["/login", "/signup", "/", "/pricing", "/terms"].includes(here)) {
        window.location.assign(`/login?next=${encodeURIComponent(here)}`);
      }
    }
    return Promise.reject(err);
  }
);

export default api;
